
/** 图片最终上传大小上限，单位为字节（500KB）。 */
const MAX_IMAGE_UPLOAD_BYTES = 500 * 1024;

/** 兼容既有本地选图逻辑的图片大小限制别名。 */
const LIMIT_FILE_SIZE = MAX_IMAGE_UPLOAD_BYTES;
/**
 * GYB 中介 Intermediary
 * - i18n 在组件内翻译
 */
const INTERMEDIARY = [{
    value: '1',
    label: 'gyb_page_text_in_te_s_a'
}, {
    value: '2',
    label: 'gyb_page_text_in_te_s_a_grandi_clienti'
}, {
    value: '3',
    label: 'gyb_page_text_fastInvoice'
}, {
    value: '4',
    label: 'gyb_page_text_seac'
}, {
    value: '5',
    label: 'gyb_page_text_infocert'
}, {
    value: '6',
    label: 'gyb_page_text_iper'
}, {
    value: '7',
    label: 'gyb_page_text_2c_solution'
}, {
    value: '8',
    label: 'gyb_page_text_camst'
}, {
    value: '9',
    label: 'gyb_page_text_agyo'
}, {
    value: '10',
    label: 'gyb_page_text_ditech'
}];


export {
    MAX_IMAGE_UPLOAD_BYTES,
    LIMIT_FILE_SIZE,
    INTERMEDIARY
}

export type PropType<T, P extends keyof T> = T[P];

export type RequiredSome<T, K extends keyof T> = Partial<T> & Pick<T, K>

export type Unpacked<T> = T extends (infer U)[] ? U : T;